module.exports = __webpack_public_path__ + "static/media/logo.8a7a8482.svg";